import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=534eb4e3&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=534eb4e3&prod&scoped=true&lang=css"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=534eb4e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534eb4e3",
  null
  
)

export default component.exports